import { useTranslation } from 'react-i18next'
import { galleryItems } from '@/mocks/gallery'
import PageSeo from '@/components/feature/PageSeo'
import { SITE_URL } from '@/utils/schema'

export default function GallerySeo() {
  const { t } = useTranslation()

  const imageGallerySchema = {
    '@context': 'https://schema.org',
    '@type': 'ImageGallery',
    name: t('pages.gallery.title'),
    description: t('pages.gallery.description'),
    url: `${SITE_URL}/gallery`,
    image: galleryItems.map((item) => item.image),
    associatedMedia: galleryItems.map((item) => ({
      '@type': 'ImageObject',
      contentUrl: item.image,
      name: t(`gallery.items.${item.id}.title`),
      description: `${t(`gallery.items.${item.id}.title`)} — ${t(`gallery.items.${item.id}.place`)}`,
    })),
  }

  return (
    <PageSeo
      title={t('seo.gallery.title')}
      description={t('seo.gallery.description')}
      path="/gallery"
      schemas={[imageGallerySchema]}
    />
  )
}